import * as React from 'react';
import { IStyledFieldsetProps, StyledFieldset } from './Section.style';

export type ISectionProps = IStyledFieldsetProps;

const Section: React.FC<IStyledFieldsetProps> = ({ children, ...props }) => {
  return <StyledFieldset {...props}>{children}</StyledFieldset>;
};

Section.defaultProps = {
  disabled: false
};

export default Section;
